import { create } from 'zustand'
import { produce } from 'immer'

export const useChecklist = create((set) => ({
  data: {
    config:{
      name: "",
      active: false,
    }
  },
  actions: {
    setConfig: (config) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.config = config
        }),
      ),
  },
}))
